






import Vue from 'vue'
import { apiGetBusinessDevicesStatistics } from '@/api'
import { portalState } from '@/state'

export default Vue.extend({
  name: 'FreeDevices',
  props: {
    tab: String,
    selectedBusiness: Object
  },
  computed: {
    canShowFreeDevices () {
      const hasPermission = portalState.user.businesses[0].show_statistics
      const notRoot = this.selectedBusiness?.type !== 'enterprise'
      if (!this.selectedBusiness || this.tab !== 'devices' || notRoot || !hasPermission) return false
      return true
    }
  },
  data () {
    return {
      freeDevices: 0
    }
  },
  methods: {
    getStatistics () {
      if (!this.selectedBusiness) return false
      this.freeDevices = 0
      const { id } = this.selectedBusiness
      apiGetBusinessDevicesStatistics(id).then(res => {
        this.freeDevices = res.data.data.free_devices
      })
    }
  },
  watch: {
    tab () {
      this.getStatistics()
    },
    selectedBusiness () {
      this.getStatistics()
    }
  },
  mounted () {
    this.getStatistics()
  }
})
